import { render } from "./DealerBenefits.vue?vue&type=template&id=f1f407be&scoped=true"
const script = {}

import "./DealerBenefits.vue?vue&type=style&index=0&id=f1f407be&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f407be"]])

export default __exports__